import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

import { createVuetify } from 'vuetify'

export default createVuetify({
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          'primary': '#5353B5',
          'error': '#FC5A5A',
          'secondary-grey': '#F5F6F7',
          'N30': '#EBEDF0',
          'N40': '#DFE2E6',
          'N50': '#C2C7D0',
          'N70': '#A6AEBB',
          'N80': '#98A1B0',
          'N100': '#7A8699',
          'N200': '#6B788E',
          'N400': '#A0ABBB',
          'N500': '#42526D',
          'N600': '#4B5768',
          'N700': '#243757',
          'N900': '#091E42',
          'S50': '#E7F8F0',
          'S300': '#12B76A',
          'S400': '#0D804A',
          'W50': '#FEF4E6',
          'W300': '#F79009',
          'W400': '#AD6506',
          'B50': '#E7F3F8',
          'B300': '#0A85B6',
          'E50': '#FFEFEF',
          'E300': '#FC5A5A',
          'success': '#3AC383',
          'primary-50': '#D4D4FF',
          'primary-600': '#5353B5',
          'score-1-bg': '#FFDA4B',
          'score-1-text': '#FF921B',
          'score-2-bg': '#FEEFE5',
          'score-2-text': '#AD6506',
          'primary-grey': '#F1F1FF',
          'primary-500': '#6A6AE8',
          'dark-border': '#B3B9C4'
        },
      },
    },
  },
  defaults: {
    VSelect: {
      variant: 'outlined',
      density: 'compact',
    },
    VSlider: {
      color: 'primary',
      thumbSize: 12,
      trackSize: 2,
    },
    VTextField: {
      variant: 'outlined',
    }
  },
})
